import {
  fetchUpdateRecommendations,
  TUpdateRecommendationsResponse,
} from '../../repositories/cian-chat-bot/v1/update-recommendations';
import { IApplicationContext } from '../../types/applicationContext';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

const DEFAULT_ERROR_MESSAGE = 'Не удалось обновить рекомендации';

export async function updateRecommendations({ httpApi, logger }: IApplicationContext): Promise<boolean> {
  try {
    const { response, statusCode }: TUpdateRecommendationsResponse = await fetchUpdateRecommendations({
      httpApi,
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chatbot,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return true;
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chatbot,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'cian-chat-bot',
      pathApi: '/v1/update-recommendations/',
    });

    return false;
  }
}
